"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describeServices = describeServices;
exports.getMonitorData = getMonitorData;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var _vue = _interopRequireDefault(require("vue"));
var _excluded = ["regionId", "pin"];
var axios = new _axios.default({
  extra: {
    componentName: 'monitor'
  }
});
function getMonitorData(oParam, preFormat) {
  var regionId = oParam.regionId,
    pin = oParam.pin,
    oRestParam = (0, _objectWithoutProperties2.default)(oParam, _excluded);
  return axios({
    url: "/openApi/monitor/batchDescribeMetricData",
    method: 'POST',
    data: {
      params: oRestParam
    },
    params: {
      regionId: regionId,
      version: 'v2',
      pin: _vue.default.prototype.$JELEMENT_BIZ_TYPE === 'back' ? pin ? pin : 'jcloud_monitor' : pin
    }
  }).then(function (oOrigin) {
    // 用户自定义数据预处理，以支持自定义legend等需求
    if (preFormat) {
      return preFormat(oOrigin);
    }
    return oOrigin;
  });
}
function describeServices(oParam, preFormat) {
  var pin = oParam.pin;
  return axios({
    url: "/openApi/monitor/describeServices",
    method: 'POST',
    data: {
      params: oParam
    },
    params: {
      pin: _vue.default.prototype.$JELEMENT_BIZ_TYPE === 'back' ? pin ? pin : 'jcloud_monitor' : pin
    }
  }).then(function (oOrigin) {
    // 用户自定义数据预处理，以支持自定义排序等需求
    if (preFormat) {
      return preFormat(oOrigin);
    }
    return oOrigin;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/monitor-dashboard.js
// module id = ews8
// module chunks = 19